<template>
    <div class="loading" :class="{'d-none': !active}">
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        active: Boolean,
    },
}
</script>
<style lang="scss" scoped>
    .loading {
        position: fixed;
        top: 0;
        height: 100%;
        width: 100%;
        background: #000000;
        opacity: 0.5;

        .spinner-border {
            position: absolute;
            top: 50%;
            left: 50%;
            height: 50px;
            width: 50px;
            color: #ffffff;
        }

    }
</style>
